import { redirect } from "react-router-dom";

import { DEFAULT_ROUTE } from "constants/routing";

export const makeRedirectTo = (defaultRoute = DEFAULT_ROUTE) => {
  return ({ request }: { request: Request }) => {
    const url = new URL(request.url);

    if (url.pathname === defaultRoute) {
      return null;
    }

    return redirect(`${defaultRoute}${url.search}`);
  };
};

export const redirectToDefault = makeRedirectTo();
